// Dark theme preset
import merge from "lodash.merge";
import light from "./light";
import copy from "fast-copy";
var dark = merge(copy(light), {
    "color-brand": {
        "primary-50": {
            label: "",
            value: "rgb(var(--color-red-50))",
            category: "theme",
        },
        "primary-100": {
            label: "",
            value: "rgb(var(--color-red-100))",
            category: "theme",
        },
        "primary-200": {
            label: "",
            value: "var(--color-red-200))",
            category: "theme",
        },
        "primary-300": {
            label: "",
            value: "rgb(var(--color-red-300))",
            category: "theme",
        },
        "primary-400": {
            label: "",
            value: "rgb(var(--color-red-400))",
            category: "theme",
        },
        "primary-500": {
            label: "",
            value: "var(--color-red-500))",
            category: "theme",
        },
        "primary-600": {
            label: "",
            value: "rgb(var(--color-red-600))",
            category: "theme",
        },
        "primary-700": {
            label: "",
            value: "rgb(var(--color-red-700))",
            category: "theme",
        },
        "primary-800": {
            label: "",
            value: "rgb(var(--color-red-800)",
            category: "theme",
        },
        "primary-900": {
            label: "",
            value: "var(--color-red-900))",
            category: "theme",
        },
        primary: {
            label: "",
            value: "rgb(var(--color-red-900))",
            category: "theme",
        },
        // --color-brand-sky
        "sky-50": {
            label: "",
            value: "rgb(var(--color-sky-50))",
            category: "theme",
        },
        "sky-100": {
            label: "",
            value: "rgb(var(--color-sky-100))",
            category: "theme",
        },
        "sky-200": {
            label: "",
            value: "var(--color-sky-200))",
            category: "theme",
        },
        "sky-300": {
            label: "",
            value: "rgb(var(--color-sky-300))",
            category: "theme",
        },
        "sky-400": {
            label: "",
            value: "rgb(var(--color-sky-400))",
            category: "theme",
        },
        "sky-500": {
            label: "",
            value: "var(--color-sky-500))",
            category: "theme",
        },
        "sky-600": {
            label: "",
            value: "var(--color-sky-600))",
            category: "theme",
        },
        "sky-700": {
            label: "",
            value: "rgb(var(--color-sky-700))",
            category: "theme",
        },
        "sky-800": {
            label: "",
            value: "var(--color-sky-800))",
            category: "theme",
        },
        "sky-900": {
            label: "",
            value: "rgb(var(--color-sky-900))",
            category: "theme",
        },
        sky: {
            label: "",
            value: "rgb(var(--color-brand-primary-700))",
            category: "theme",
        },
        // ! --color-brand-light
        light: {
            label: "",
            value: "var(--color-white)",
            category: "theme",
        },
        // ! --color-brand-dark
        "dark-50": {
            label: "",
            value: "rgb(var(--color-gray-50))",
            category: "theme",
        },
        "dark-100": {
            label: "",
            value: "var(--color-gray-100))",
            category: "theme",
        },
        "dark-200": {
            label: "",
            value: "rgb(var(--color-gray-200))",
            category: "theme",
        },
        "dark-300": {
            label: "",
            value: "rgb(var(--color-gray-300))",
            category: "theme",
        },
        "dark-400": {
            label: "",
            value: "var(--color-gray-400))",
            category: "theme",
        },
        "dark-500": {
            label: "",
            value: "rgb(var(--color-gray-500))",
            category: "theme",
        },
        "dark-600": {
            label: "",
            value: "var(--color-gray-600))",
            category: "theme",
        },
        "dark-700": {
            label: "",
            value: "var(--color-gray-700))",
            category: "theme",
        },
        "dark-800": {
            label: "",
            value: "rgb(var(--color-gray-800))",
            category: "theme",
        },
        "dark-900": {
            label: "",
            value: "rgb(var(--color-gray-900))",
            category: "theme",
        },
        black: {
            label: "",
            value: "#000000",
            category: "theme",
        },
    },
    colors: {
        //row grid
        "bg-neutral": {
            label: "label color",
            value: "rgb(var(--color-gray-600))",
            category: "general",
        },
        //label
        //content
        //facelift
        //subpanel
        /* "subpanel-bg": {
          label: "subpanel background",
          value: `rgb(var(--color-gray-600))`,
          category: "general",
        },*/
        //tabs
        //tab
        // ! Main
        "body-bg": {
            label: " Background Color",
            value: "rgb(var(--color-gray-800))",
            category: "general",
        },
        "body-bg-sec": {
            label: " Background Color",
            value: "rgb(var(--color-gray-600))",
            category: "general",
        },
        "bg-default": {
            label: "Default Background Color",
            value: "rgb(var(--color-neutral-800))",
            category: "general",
        },
        //widget
        "widget-border": {
            label: "widget color",
            value: "rgb(var(--color-gray-400))",
        },
        // ! header && footer
        "header-bg": {
            label: "Header Background Color",
            value: "#000000",
            category: "general",
            tags: ["colors"],
        },
        "footer-bg": {
            label: "Footer Background Color",
            value: "#000000",
            category: "general",
            tags: ["colors"],
        },
        // ! Borders
        "layout-separator": {
            label: "Layout Separator Color",
            value: "var(--color-brand-dark-900)",
            category: "borders",
        },
        "background-body": {
            label: "Couleur de fond",
            value: "var(--color-brand-common-black)",
            category: "general",
            tags: ["colors"],
        },
        "background-level1": {
            label: "Couleur de fond level1",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "background-level2": {
            label: "Couleur de fond level2",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "background-level3": {
            label: "Couleur de fond level3",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        "background-popup": {
            label: "Couleur de popup",
            value: "var(--color-brand-common-black)",
            category: "general",
            tags: ["colors"],
        },
        "background-popup-sec": {
            label: "Couleur de popup",
            value: "rgb(var(--color-gray-800))",
            category: "general",
            tags: ["colors"],
        },
        "background-surface": {
            label: "Couleur de surface",
            value: "var(--color-brand-neutral-900)",
            category: "general",
            tags: ["colors"],
        },
        "background-tooltip": {
            label: "Couleur de tooltip",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        // danger
        "danger-outlinedActiveBg": {
            label: "Couleur danger de fond du bordure active",
            value: "var(--color-brand-danger-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedBorder": {
            label: "Couleur danger de fond du bordure",
            value: "var(--color-brand-danger-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedColor": {
            label: "Couleur danger de bordure",
            value: "var(--color-brand-danger-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedDisabledBorder": {
            label: "Couleur danger d' outlinedDisabledBorder",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedDisabledColor": {
            label: "Couleur danger d'outlinedDisabled",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedHoverBg": {
            label: "Couleur danger d'outlinedHoverBg",
            value: "var(--color-brand-danger-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainActiveBg": {
            label: "Couleur danger de plainActiveBg",
            value: "var(--color-brand-danger-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainColor": {
            label: "Couleur danger de plainColor",
            value: "var(--color-brand-danger-300)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainDisabledColor": {
            label: "Couleur danger de plainDisabledColor",
            value: "var(--color-brand-danger-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainHoverBg": {
            label: "Couleur danger de plainHoverBg",
            value: "var(--color-brand-danger-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softActiveBg": {
            label: "Couleur danger de softActiveBg",
            value: "var(--color-brand-danger-600)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softActiveColor": {
            label: "Couleur danger de softActiveColor",
            value: "var(--color-brand-danger-100)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softBg": {
            label: "Couleur danger de softBg",
            value: "var(--color-brand-danger-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softColor": {
            label: "Couleur danger de softColor",
            value: "var(--color-brand-danger-200)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softDisabledBg": {
            label: "Couleur danger de softDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softDisabledColor": {
            label: "Couleur danger de softDisabledBg",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softHoverBg": {
            label: "Couleur danger de softHoverBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidActiveBg": {
            label: "Couleur danger de solidActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidBg": {
            label: "Couleur danger de solidBg",
            value: "var(--color-brand-danger-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidColor": {
            label: "Couleur danger de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidDisabledBg": {
            label: "Couleur danger de solidDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidDisabledColor": {
            label: "Couleur danger de solidDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidHoverBg": {
            label: "Couleur danger de solidHoverBg",
            value: "var(--color-brand-danger-600)",
            category: "general",
            tags: ["colors"],
        },
        //neutral
        "neutral-outlinedActiveBg": {
            label: "Couleur neutral de outlinedActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedBorder": {
            label: "Couleur neutral de outlinedBorder",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedColor": {
            label: "Couleur neutral de outlinedColor",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedDisabledBorder": {
            label: "Couleur neutral de outlinedDisabledBorder",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedDisabledColor": {
            label: "Couleur neutral de outlinedDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedHoverBg": {
            label: "Couleur neutral de outlinedHoverBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainActiveBg": {
            label: "Couleur neutral de plainActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainColor": {
            label: "Couleur neutral de plainColor",
            value: "var(--color-brand-neutral-300)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainDisabledColor": {
            label: "Couleur neutral de plainDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainHoverBg": {
            label: "Couleur neutral de plainHoverBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainHoverColor": {
            label: "Couleur neutral de plainHoverColor",
            value: "var(--color-brand-neutral-300)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softActiveBg": {
            label: "Couleur neutral de softActiveBg",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softActiveColor": {
            label: "Couleur neutral de softActiveColor",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softBg": {
            label: "Couleur neutral de softBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softColor": {
            label: "Couleur neutral de softColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softDisabledBg": {
            label: "Couleur neutral de solidHoverBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softDisabledColor": {
            label: "Couleur neutral de solidHoverBg",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softHoverBg": {
            label: "Couleur neutral de softHoverBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidActiveBg": {
            label: "Couleur neutral de solidActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidBg": {
            label: "Couleur neutral de solidBg",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidColor": {
            label: "Couleur neutral de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidDisabledBg": {
            label: "Couleur neutral de solidDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidDisabledColor": {
            label: "Couleur neutral de solidDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidHoverBg": {
            label: "Couleur neutral de solidHoverBg",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        // primary
        "primary-outlinedActiveBg": {
            label: "Couleur primary d'outlinedActiveBg",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedBorder": {
            label: "Couleur primary d'outlinedBorder",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedColor": {
            label: "Couleur primary d'outlinedColor",
            value: "var(--color-brand-primary-200)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedDisabledBorder": {
            label: "Couleur primary d'outlinedDisabledBorder",
            value: "var(--color-brand-primary-800)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedDisabledColor": {
            label: "Couleur primary d'outlinedDisabledColor",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedHoverBg": {
            label: "Couleur primary d'outlinedHoverBg",
            value: "var(--color-brand-primary-800)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainActiveBg": {
            label: "Couleur primary de plainActiveBg",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainColor": {
            label: "Couleur primary de plainColor",
            value: "var(--color-brand-primary-300)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainDisabledColor": {
            label: "Couleur primary de plainDisabledColor",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainHoverBg": {
            label: "Couleur primary de plainHoverBg",
            value: "var(--color-brand-primary-800)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softActiveBg": {
            label: "Couleur primary de softActiveBg",
            value: "var(--color-brand-primary-600)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softActiveColor": {
            label: "Couleur primary de softActiveColor",
            value: "var(--color-brand-primary-100)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softBg": {
            label: "Couleur primary de softBg",
            value: "var(--color-brand-primary-800)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softColor": {
            label: "Couleur primary de softColor",
            value: "var(--color-brand-primary-200)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softDisabledColor": {
            label: "Couleur primary de softDisabledColor",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softHoverBg": {
            label: "Couleur primary de softHoverBg",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidActiveBg": {
            label: "Couleur primary de solidActiveBg",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidBg": {
            label: "Couleur primary de solidBg",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidColor": {
            label: "Couleur primary de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidDisabledBg": {
            label: "Couleur primary de solidDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidDisabledColor": {
            label: "Couleur primary de solidDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidHoverBg": {
            label: "Couleur primary de solidHoverBg",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        // success
        "success-outlinedActiveBg": {
            label: "Couleur success d'outlinedActiveBg",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedBorder": {
            label: "Couleur success d'outlinedBorderg",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedColor": {
            label: "Couleur success d'outlinedColor",
            value: "var(--color-brand-success-200)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedDisabledBorder": {
            label: "Couleur success d'outlinedDisabledBorder",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedDisabledColor": {
            label: "Couleur success d'outlinedDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedHoverBg": {
            label: "Couleur success d'outlinedHoverBg",
            value: "var(--color-brand-success-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainActiveBg": {
            label: "Couleur success de plainActiveBg",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainColor": {
            label: "Couleur success de plainColor",
            value: "var(--color-brand-success-300)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainDisabledColor": {
            label: "Couleur success de plainDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainHoverBg": {
            label: "Couleur success de plainHoverBg",
            value: "var(--color-brand-success-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-softActiveBg": {
            label: "Couleur success de softActiveBg",
            value: "var(--color-brand-success-600)",
            category: "general",
            tags: ["colors"],
        },
        "success-softActiveColor": {
            label: "Couleur success de softActiveColor",
            value: "var(--color-brand-success-100)",
            category: "general",
            tags: ["colors"],
        },
        "success-softBg": {
            label: "Couleur success de softBgr",
            value: "var(--color-brand-success-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-softColor": {
            label: "Couleur success de softColor",
            value: "var(--color-brand-success-200)",
            category: "general",
            tags: ["colors"],
        },
        "success-softDisabledBg": {
            label: "Couleur success de softDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-softDisabledColor": {
            label: "Couleur success de softDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-softHoverBg": {
            label: "Couleur success de softHoverBg",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidActiveBg": {
            label: "Couleur success de solidActiveBg",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidBg": {
            label: "Couleur success de solidBg",
            value: "var(--color-brand-success-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidColor": {
            label: "Couleur success de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidDisabledBg": {
            label: "Couleur success de solidDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidDisabledColor": {
            label: "Couleur success de solidDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidHoverBg": {
            label: "Couleur success de solidHoverBg",
            value: "var(--color-brand-success-600)",
            category: "general",
            tags: ["colors"],
        },
        // text
        "text-icon": {
            label: "Couleur d'icon",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "text-primary": {
            label: "Couleur de texte primaire",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "text-secondary": {
            label: "Couleur de texte secondaire",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        // warning
        "warning-outlinedActiveBg": {
            label: "Couleur warning d'outlinedActiveBg",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedBorder": {
            label: "Couleur warning d'outlinedBorder",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedColor": {
            label: "Couleur warning d'outlinedColor",
            value: "var(--color-brand-warning-200)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedDisabledBorder": {
            label: "Couleur warning d'outlinedDisabledBorder",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedDisabledColor": {
            label: "Couleur warning d'outlinedDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedHoverBg": {
            label: "Couleur warning d'outlinedHoverBg",
            value: "var(--color-brand-warning-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainActiveBg": {
            label: "Couleur warning de plainActiveBg",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainColor": {
            label: "Couleur warning de plainColor",
            value: "var(--color-brand-warning-300)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainDisabledColor": {
            label: "Couleur warning de plainDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainHoverBg": {
            label: "Couleur warning de plainHoverBg",
            value: "var(--color-brand-warning-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softActiveBg": {
            label: "Couleur warning de softActiveBg",
            value: "var(--color-brand-warning-600)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softActiveColor": {
            label: "Couleur warning de softActiveColor",
            value: "var(--color-brand-warning-100)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softBg": {
            label: "Couleur warning de softBg",
            value: "var(--color-brand-warning-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softColor": {
            label: "Couleur warning de softColor",
            value: "var(--color-brand-warning-200)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softDisabledBg": {
            label: "Couleur warning de softDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softDisabledColor": {
            label: "Couleur warning de softDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softHoverBg": {
            label: "Couleur warning de softHoverBg",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidActiveBg": {
            label: "Couleur warning de solidActiveBg",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidBg": {
            label: "Couleur warning de solidBg",
            value: "var(--color-brand-warning-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidColor": {
            label: "Couleur warning de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidDisabledBg": {
            label: "Couleur warning de solidDisabledBg",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidDisabledColor": {
            label: "Couleur warning de solidDisabledColor",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidHoverBg": {
            label: "Couleur warning de solidHoverBg",
            value: "var(--color-brand-warning-600)",
            category: "general",
            tags: ["colors"],
        },
        // ! Links
        link: {
            value: "var(--color-brand-dark-200)",
        },
        "link--hover": {
            value: "var(--color-brand-dark-100)",
        },
        "link--visited": {
            value: "var(--color-brand-dark-100)",
        },
        "link--focus": {
            value: "var(--color-brand-dark-100)",
        },
        // ! Button colors
        "button-primary-text": {
            //value: "var(--color-brand-dark-900)",
            value: "#ffffff",
        },
        //secondary
        //link
        "button-link": {
            value: "rgb(var(--color-brand-indigo-500)",
        },
        "button-link--hover": {
            value: "var(--color-brand-indigo-500)",
        },
        "button-link-text": {
            value: "rgb(var(--color-brand-indigo-600)",
        },
        //info
        "button-info-border": {
            value: "rgb(var(--color-blue-900))",
        },
        "button-info--hover": {
            value: "rgb(var(--color-blue-700))",
        },
        "button-info-text": {
            value: "#ffffff",
        },
        //success
        "button-success-border": {
            value: "rgb(var(--color-green-900))",
        },
        "button-success-text": {
            value: "#ffffff",
        },
        //warning
        "button-warning-border": {
            value: "rgb(var(--color-orange-900))",
        },
        "button-warning-text": {
            value: "#ffffff",
        },
        //danger
        "button-danger-border": {
            value: "rgb(var(--color-red-900))",
        },
        "button-danger-text": {
            value: "#ffffff",
        },
        // ! Views
        "page-bg": {
            value: "var(--color-brand-dark-900)",
        },
        "page-fg": {
            value: "var(--color-brand-dark-400)",
        },
        // ! Layouts colors
        "nav-brand-bg": {
            label: "Navbar Brand",
            value: "#3c4b64",
            category: "colors",
        },
        //MENU
        //select option
        "select-option-bg": {
            value: "var(--color-black)",
        },
        "select-option-text": {
            value: "var(--color-white)",
        },
        //input
        "input-bg": {
            value: "#0B1829",
        },
        "input-border": {
            value: "rgb(var(--color-gray-700))",
        },
        "input-text": {
            value: "var(--color-white)",
        },
        "input-flag-bg": {
            value: "#0B1829",
        },
        "input-flag-bg-sec": {
            value: "rgb(var(--color-gray-500))",
        },
    },
});
export default dark;
